import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import PickupLopList from '../../components/PickupLopList';

class PickupLop extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Delivery',
      },
      {
        breadcrumbName: 'Performance',
      },
    ];

    const dispatchListColumns = [
      {
        Header: 'Dispatch ID',
        accessor: 'dh_id',
      },
      {
        Header: 'Courier',
        accessor: 'driver',
      },
      {
        Header: 'Status',
        accessor: 'status',
        sortable: false,
      },
      {
        Header: 'Date',
        accessor: 'dispatch_date',
      },
    ];

    const customFilter = {
      id: 'type',
      value: 'delivery',
    };

    return (
      <div className="DeliveryList">
        <PageHeader title="Pickup Performance " routes={breadCrumbs} />
        <Container>
          <PickupLopList
            hasExport
            dispatchListColumns={dispatchListColumns}
            customFilter={customFilter}
            fetchText="Fetching Delivery List. . ."
            urlEndpoint="/delivery"
            typeDispatch="delivery"
          />
        </Container>
      </div>
    );
  }
}

export default PickupLop;
